import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { TranslatorContext } from './i18n/jhipster-language';
import { hostLocaleToCmsLocale, registerCmsTranslations } from './i18n/register-translations';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './cms/cms-primeflex-compat.css';
import './cms/cms-app.css';
import { CmsProviders } from 'app/providers';
import { CmsRouter } from 'app/router';
let translationsRegistered = false;
const CMS_LOCALE_STORAGE_KEY = 'cms-mfe-locale';
/** Card CMS — self-contained iframe app. Locale and API base URL are configured here, not by the host. */
const CmsApp = ({ apiBaseUrl, getAccessToken, getWalletAccessToken, walletApiBase }) => {
    useEffect(() => {
        if (!translationsRegistered) {
            registerCmsTranslations();
            translationsRegistered = true;
        }
        const savedLocale = localStorage.getItem(CMS_LOCALE_STORAGE_KEY);
        TranslatorContext.setLocale(hostLocaleToCmsLocale(savedLocale || 'en'));
    }, []);
    return (_jsx(CmsProviders, { apiBaseUrl: apiBaseUrl, getAccessToken: getAccessToken, getWalletAccessToken: getWalletAccessToken, walletApiBase: walletApiBase, children: _jsx(CmsRouter, {}) }));
};
export default CmsApp;
